import { unit } from '@othrworld/units';
import { rotateCarth } from './coords';
import { getApoapsis, getPeriapsis } from './orbit-characteristics';
import { getRadialCoords } from './position';
import { G } from './utils';
export const getSpeedAtDistance = (orbit, r) => unit(Math.sqrt(G * orbit.parentMass * (2 / r - 1 / orbit.a)));
export const getSpeed = (orbit, t) => getSpeedAtDistance(orbit, getRadialCoords(orbit, t).r);
export const getSpeedAtPeriapsis = (orbit) => getSpeedAtDistance(orbit, getPeriapsis(orbit));
export const getSpeedAtApoapsis = (orbit) => getSpeedAtDistance(orbit, getApoapsis(orbit));
/** Returns a carthesian vector describing the speed item on the orbit */
export const getSpeedVector = (orbit, t) => {
    const { angle } = getRadialCoords(orbit, t);
    const p = orbit.a * (1 - orbit.e * orbit.e);
    return rotateCarth({
        x: unit(-Math.sqrt((G * orbit.parentMass) / p) * Math.sin(angle)),
        y: unit(Math.sqrt((G * orbit.parentMass) / p) * (orbit.e + Math.cos(angle))),
    }, orbit.phi);
};
//# sourceMappingURL=speed.js.map